import { render, staticRenderFns } from "./PluSection.vue?vue&type=template&id=50846f86&scoped=true"
import script from "./PluSection.vue?vue&type=script&lang=js"
export * from "./PluSection.vue?vue&type=script&lang=js"
import style0 from "./PluSection.vue?vue&type=style&index=0&id=50846f86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50846f86",
  null
  
)

export default component.exports